import { render, staticRenderFns } from "./UploadSetting.vue?vue&type=template&id=7f5aa467&scoped=true&"
import script from "./UploadSetting.vue?vue&type=script&lang=ts&"
export * from "./UploadSetting.vue?vue&type=script&lang=ts&"
import style0 from "./UploadSetting.vue?vue&type=style&index=0&id=7f5aa467&prod&lang=scss&scoped=true&"
import style1 from "./UploadSetting.vue?vue&type=style&index=1&id=7f5aa467&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5aa467",
  null
  
)

export default component.exports